<template>
  <v-layout row wrap v-show="elementoPai.tipoCliente.opened" align-center justify-center>
    <v-flex xs12 sm8 md8 lg6>
      <v-card style="padding: 15px;">
        <v-layout row wrap align-center justify-center>
          <v-card-text>
            <v-form>
              <v-flex xs12 class="text-xs-center">
                <span class="primary--text"><b>Qual sua modalidade de atuação?*</b></span>
                <br><br>
                <v-layout row wrap align-center justify-center>
                  <v-flex xs9 v-for="itemTipoCliente in opcoes" :key="itemTipoCliente.id">
                    <v-btn :id="`btn_${itemTipoCliente.descricao}`"
                      @click="tipoCliente = itemTipoCliente"
                      :color="tipoClienteSelecionado.id == itemTipoCliente.id ? 'primary' : 'themeGrey'"
                      round
                      block
                      :outline="tipoClienteSelecionado.id != itemTipoCliente.id"
                    >{{itemTipoCliente.descricao}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-layout row wrap align-center justify-center>
            <br><br><br><br>
            <v-flex xs6>
              <v-btn id="btn_voltar" ref="btn_voltar"
              color="primary" flat
              @click="voltar()">Voltar</v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs6>
              <v-btn id="btn_proximo" ref="btn_proximo" class="right"
              color="secondary"
              :disabled="!formValid"
              @click="proximo()">Próximo</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'

export default {
  name: "TipoCliente",
  data: function() {
    return {
      tipoCliente: null,
      opcoes: [ {id: 1, descricao: 'Transportador'}, {id: 2, descricao: 'Embarcador'} ]
    }
  },
  computed: {
    elementoPai: function () {
      return this.$parent;
    },
    tipoClienteSelecionado: function() {
      const self = this;
      if (self.tipoCliente) {
        return self.tipoCliente;
      } else {
        return { id: 0, descricao: '' };
      }
    },
    formValid: function() {
      const self = this;
      return  self.tipoCliente != null &&
              (self.tipoCliente.id == 1 || self.tipoCliente.id == 2);
    }
  },
  methods: {
    voltar: function() {
      const self = this;
      self.elementoPai.tipoCliente.opened = false;
      self.elementoPai.premioApoliceAnterior.opened = true;
    },
    proximo: function() {
      const self = this;
      self.elementoPai.tipoCliente.valor = self.tipoCliente;
      self.elementoPai.tipoCliente.opened = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/questionario/TipoCliente.vue